module.exports = __webpack_public_path__ + "img/video.654fc03b.png";